import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { CacheKeys } from "../../shared/consts/keys.consts"
import { compliancesService } from "./compliances.service"
import type { UpdateComplianceInput } from "@montatec/contracts"


type Props = {
  enabled: boolean
}

export function useCompliances({enabled} : Props) {
  return useQuery({
    queryKey: CacheKeys.compliances,
    queryFn: compliancesService.get,    
    enabled: enabled
  })
}

export function useCompliancesMutations() {
  const qc = useQueryClient()

  const updateCompliance = useMutation({
    mutationFn: ({id, data} : {id: number, data: UpdateComplianceInput}) => compliancesService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.compliances }),
  })
    
  return { updateCompliance }
}
